import { Injectable } from '@angular/core';
import { RestService } from '../services/rest.service';
import { environment } from '../../environments/environment';
import { Observable, Subject } from 'rxjs';
import { NgRedux } from '@angular-redux/store';
import { InitialState } from '../store/reducer';
import { GetConversations } from '../store/actions';
import { SetActiveConversation, PushConversation } from '../store/actions';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  conversations: any;
  constructor(
    private ngRedux: NgRedux<InitialState>,
    private restService: RestService
  ) {
    this.ngRedux
      .select<Array<Object>>('conversations')
      .subscribe((conversations: Array<Object>) => {
        if (conversations) {
          this.conversations = conversations;
        }
      });
  }

  getNewRoomId(users, postId, subject?: Subject<any>) {
    let data = {
      users: users,
      postId: postId,
      dateTimeUTC: new Date().toISOString(),
    };
    this.restService
      .POST(`${environment.apiUrl}/room`, data, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
      .pipe(finalize(() => {}))
      .subscribe({
        next: (conversation) => {
          const roomDetails = conversation.room[0];
          this.ngRedux.dispatch(PushConversation(roomDetails));
          this.ngRedux.dispatch(SetActiveConversation(roomDetails));
          if (subject) { subject.next(roomDetails); subject.complete(); }
        },
        error: (err) => {
          if (subject) { subject.error(err); }
        },
      });
  }

  getConversations() {
    this.restService
      .GET(`${environment.apiUrl}/chat`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
      .subscribe((resp) => {
        if (resp && resp.length) {
          this.ngRedux.dispatch(GetConversations(resp));
        }
      });
  }

  getChat(users, postId) {
    let conversation = null;
    (this.conversations || []).forEach((chat) => {
      if (chat.post_id == postId) {
        const chatUsers: string[] = Array.isArray(chat.users) ? chat.users : [];
        const filteredArray = chatUsers.filter((value) => users.includes(value));
        if (chatUsers.length === filteredArray.length && chatUsers.length > 0) {
          conversation = chat;
        }
      }
    });
    return conversation;
  }

  createConversation(users, postId) {
    this.restService
      .GET(`${environment.apiUrl}/chat`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
      .subscribe({
        next: (resp) => {
          if (resp && resp.length) {
            this.ngRedux.dispatch(GetConversations(resp));
          }
          const conversation = this.getChat(users, postId);
          if (conversation) {
            this.ngRedux.dispatch(SetActiveConversation(conversation));
          } else {
            this.getNewRoomId(users, postId);
          }
        },
        error: () => {
          this.getNewRoomId(users, postId);
        },
      });
  }
}
